import React, { ReactElement } from "react";
import MainImg from "./mainImg";

import SharedButton from "../sharedButton";
export default function WhatIsCarWarrantyCategoryPage(): ReactElement {
    return (
        <section className="flex flex-col lg:flex-row lg:gap-28 gap-16  lg:mt-28 mt-14  ">
            <div className="max-w-[574px]  mx-auto lg:mx-0 order-1 lg:order-2">
                <h2 className="font-bold lg:text-3xl text-2xl lg:leading-[45px] ">
                    What Is a Car Warranty?
                </h2>
                <p className="mt-5   lg:text-lg text-base lg:leading-8  font-light">
                    A car warranty is a contract between you and your vehicle's
                    automaker (or the provider of the coverage in the case of an
                    extended warranty). In simple terms, it says that they will
                    pay for repairs when a defective part or failure of
                    workmanship causes your vehicle or one of its components to
                    fail.
                </p>
                <p className="   lg:text-lg text-base lg:leading-8  font-light">
                    A new car warranty can fill dozens of pages - or more - with
                    what's covered, what's not, legalese, exceptions and
                    stipulations. Most new car warranties are similar in their
                    broad coverage but may have minor differences. Extended
                    warranties can vary significantly regarding what's covered,
                    who pays, where you can get your car serviced and how much
                    of a deductible you're responsible for.
                </p>
                <div className="lg:mt-[50px] mt-7 text-center sm:text-left">
                    <SharedButton />
                </div>
                <span className="w-[122px] h-[8px] lg:block bg-[#F02B17] mt-9 hidden"></span>
            </div>
            <div className="w-[250px] h-[250px] md:h-[400px] md:w-[402px] md:min-w-[402px] relative mx-auto  lg:mt-16 order-2 lg:order-1">
                <MainImg />
            </div>
        </section>
    );
}
